module.exports = __webpack_public_path__ + "img/mazda-logo.841d6b41.jpg";